/**
 * @generated SignedSource<<7495871da90b395d6e5b4a449165596a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CategoryPickerQuery$variables = {};
export type CategoryPickerQuery$data = {
  readonly allCategories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly rowId: string;
        readonly title: string;
      } | null;
    }>;
  } | null;
};
export type CategoryPickerQuery = {
  response: CategoryPickerQuery$data;
  variables: CategoryPickerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "condition",
        "value": {
          "active": true
        }
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 1000
      }
    ],
    "concreteType": "CategoriesConnection",
    "kind": "LinkedField",
    "name": "allCategories",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CategoriesEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rowId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "allCategories(condition:{\"active\":true},first:1000)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CategoryPickerQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CategoryPickerQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a323e9bc78075e55bcad316a3294ab4e",
    "id": null,
    "metadata": {},
    "name": "CategoryPickerQuery",
    "operationKind": "query",
    "text": "query CategoryPickerQuery {\n  allCategories(first: 1000, condition: {active: true}) {\n    edges {\n      node {\n        id\n        rowId\n        title\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7aa41d7f7b5cfc8219fa482bd132a367";

export default node;
